<template>
  <div class="pre-annotation-poly-info-container">
    <div class="pre-annotation-poly-info-title">
      <div class="name ellipsis">{{ target['annotationName'] }}</div>
      <div class="time">{{ dayjs(new Date).format('YYYY/MM/DD HH:mm:ss') }}</div>
    </div>
    <div class="pre-annotation-poly-info-feature">
      <div class="feature-tags feature-tags-diff" v-if="target['ifContinuousStatistics']" >持续统计</div>
      <div class="feature-tags feature-tags-diff" v-if="target['ifContinuousTracking']" >持续跟踪</div>
      <div class="feature-tags" v-for="(tag, index) of target['regionFeatureList']||[]"
        :key="index"
      >{{ tag.name }}</div>
    </div>
    <el-scrollbar class="pre-annotation-poly-info-track el-scrollbar-column"
      max-height="11.25rem"
    >
      <!-- v-if="target['ifContinuousStatistics']" -->
      <div style="height: 2.5rem" v-loading="trackLoad" v-if="trackLoad"></div>
      <el-card
        v-else
        v-for="(item, index) of trackList"
        :key="index"
        shadow="hover"
      >
        <el-checkbox v-model="item['check']" :label="item['name']" size="small"
          @change="trackChange($event, item)"
        />
        <el-tag type="primary">{{ item['val'].length }}</el-tag>
      </el-card>
    </el-scrollbar>
    <div class="pre-annotation-poly-info-desc">
      {{ target['regionIntention'] }}
    </div>
  </div>
</template>

<script setup>
import {
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, toRaw, reactive,
} from 'vue';
import { isNull, dayjs, message, trackListChange } from '@/utils/js/initVariable';

import store from '@/store';

import { queryContinuousStatisticsRegionDirectoryTrack } from '@/api/RegionDirectoryApi';

import { antPath } from '@/utils/js/leaflet-plug/leaflet-ant-path-master/src/plugin/main.js'

// props
const props = defineProps({
  target: { type: Object, },
  layer: { type: Object, },
});
// emit
const emit = defineEmits([
  
]);

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  layerEventInit();
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{
  layerGroupClose();
});

const homeMap = computed(()=> store.getters.getHomeMap ),
  map = toRaw(homeMap.value),
  layerGroup = L.featureGroup().addTo(map),
  layerGroupClose = ()=>{
    map.removeLayer(layerGroup);
  }
const layerEventInit = ()=>{
  // 组件挂载即请求数据（不再依赖已废弃的 popupopen 事件）
  queryContinuousStatisticsRegionDirectoryTrackFn(props.target);
}

const tooltipChange = (item)=>{
  // console.log(item);
  return `
    <p>${ item['classification'] }</p>
    <p>开始时间：${ item['startTime'] }</p>
    <p>结束时间：${ item['endTime'] }</p>
    <p>呼号：${ item['trackCall'] }</p>
    <p>编号：${ item['trackCode'] }</p>
  `;
}

const trackChange = (check, item)=>{
  // console.log(check, item);
  let { name, val, group } = item;
  if(check){
    if(!group){
      group = L.featureGroup();
      val.forEach(item => {
        const json = JSON.parse(item['trackJson']).map(e=>{
          return {
            lat: e.at(2), lon: e.at(3), time: dayjs(e.at(1)).format('YYYY-MM-DD HH:mm:ss'),
            alt: e.at(4), angle: e.at(6),
          }
        });
        const trackJson = trackListChange(json);
        const line = L.polyline.antPath(
          trackJson
        , {
          // color: '#FF0000',
          // pulseColor: '#FFFFFF',
          delay: 400,
          weight: 5,
          dashArray: [10, 20]
        }).on({
          mouseover: mouseover=>{
            line.setStyle({
              color: '#FF0000',
              pulseColor: '#FFFFFF',
            });
          },
          mouseout: mouseout=>{
            line.setStyle({
              color: '#0000FF',
              pulseColor: '#FFFFFF',
            });
          },
        }).bindTooltip(tooltipChange(item), {
          className: "leaflet-tooltip-message",
          direction: 'top',
          sticky: true,
        }).addTo(group);
        // console.log(line);
      });
      item['group'] = group;
    }
    layerGroup.addLayer(group);
  }else{
    group && layerGroup.removeLayer(group);
  }
}

const trackLoad = ref(true), trackMap = reactive(new Map()), trackList = computed(()=>{
  const list = [];
  trackMap.forEach((val, key)=>{
    // console.log(val, key);
    list.push({
      name: key,
      val,
    })
  })
  return list;
})

const trackDataInit = (data)=>{
  data.forEach(item => {
    const { classification, pointNumber } = item,
          list = trackMap.get(classification) || [];
    list.push(item);
    trackMap.set(classification, list);
  });
}

const queryContinuousStatisticsRegionDirectoryTrackFn = (target)=>{
  queryContinuousStatisticsRegionDirectoryTrack({
    taskIds: target['taskIds'],
    regionGeom: target['geom'] || target['regionGeom'],
  }).then(res=>{
    if(res.data.code == 1004){
      trackDataInit(res.data.data || []);
    }
  }).catch(err=>{
    console.log(err);
  }).finally(()=>{
    trackLoad.value = false;
  });
}

</script>

<style lang='less'>
.pre-annotation-poly-info-container{
  .pre-annotation-poly-info-track{
    .el-loading-mask{
      background-color: transparent;
    }
    .el-card{
      .el-card__body{
        padding: 5px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
}
</style>

<style lang='less' scoped>
.pre-annotation-poly-info-container{
  width: 360px;
  background-color: var(--backgroundColor_19);
  border: 2px solid var(--borderColor_3);
  padding: 10px;
  border-radius: var(--borderRadiusSize_3);
  display: flex;
  gap: 8px;
  flex-direction: column;
  backdrop-filter: blur(15px);
  pointer-events: auto;
  .pre-annotation-poly-info-title{
    .name, .time{
      line-height: 20px;
    }
    .name{
      font-size: 16px;
      color: var(--fontColor_3);
    }
    .time{
      font-size: 14px;
      color: var(--fontColor_18);
    }
  }
  .pre-annotation-poly-info-feature{
    display: flex;
    gap: 5px;
    flex-wrap: wrap;
    .feature-tags{
      border-radius: var(--borderRadiusSize_4);
      padding: 5px;
      font-size: 14px;
      color: var(--fontColor_18);
      background-color: var(--backgroundColor_36);
    }
    .feature-tags-diff{
      color: var(--fontColor);
      background-color: var(--backgroundColor_39);
    }
  }
  .pre-annotation-poly-info-desc{
    font-size: 12px;
    color: rgb(158, 166, 173);
  }
  
}
</style>